import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";
import styles from "./profile.module.css";

const ProfilePicDiv = styled.div`
width: 35%;
height: 25%;
border-radius: 46%;
/* background-color: #c5bebe; */
margin:15px auto;
/* box-shadow: 1px 1px 1px grey; */
img {
    width: 65px;
    height: 65px;
    border-radius: 35px;
}
`;
const ProfileSmall = styled.div`
padding: 5px;
background-color: white;
width: 190px;
border-radius: 8px;
/* display: flex;
flex-direction: column; */
min-height: 250px;
max-height: 260px;
margin:9px;
margin-top: 16px;
margin-bottom: 0;
/* border:1px solid #02162b; */
border:1px solid #ebeef1;
`;

export const ProfileSmallComp = ({ item }) => {
    const [owner, setOwner] = useState(false);
    const history = useHistory();
    const loggedInUser = useSelector(state => state.loggedInUser);
    const loggedIn = useSelector(state => state.loggedIn);
    const token = useSelector(state => state.token);
    const [isFollowing, setIsFollowing] = useState(false);
    const url = process.env.REACT_APP_url;

    const handleFollow = (username) => {
        if (!loggedIn) {
            history.push("/login");
        } else {
            setIsFollowing(true);
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            axios.patch( 
                `${url}/users/follow/${username}`,{}, config)
                .then((data) => {
                    // console.log(data)
                    // setChanged(!changed);
                })
                .catch((err) => {
                    alert(err);
                })
        }
    }
    const handleUnfollow = (username) => {
        setIsFollowing(false);
        const config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            axios.patch( 
                `${url}/users/unfollow/${username}`,{}, config)
                .then((data) => {
                    // console.log(data)
                    // setChanged(!changed);
                })
                .catch((err) => {
                    alert(err)
                    // console.log(err);
                })
    }
    useEffect(() => {
        axios.get(`${url}/users/${item.username}/followers`)
            .then((res) => {
                // console.log(res.data.followers);
                for (let element of res.data.followers) {
                    if (element._id === loggedInUser?._id) {
                        setIsFollowing(true);
                        break;
                    }
                }
            })
            .catch((err) => {
                alert(err);
            })
        if (loggedInUser._id == item._id) {
            setOwner(true);
        }
    }, [])
    return (
        <ProfileSmall style={{cursor:"pointer"}} >
            <ProfilePicDiv onClick={() => {window.location.href=`/users/${item.username}`}}>
                <img src={item.profile_pic} alt="profile"/>
            </ProfilePicDiv>
            <div className={styles.listName}>{item.name}</div>
            <div className={styles.listTag}>{item.tagline}</div>
            {(!isFollowing && !owner) ? <button onClick={() => handleFollow(item.username)} className={styles.btn}>Follow</button> : (!owner) ? <button onClick={() => handleUnfollow(item.username)} className={styles.btnSpl}>Following</button> : null}
        </ProfileSmall>
    )
}